export default __webpack_public_path__ + "static/media/hays.5851e935.png";